module.exports = __webpack_public_path__ + "static/media/skyll.6ed607df.mp3";